module.exports = __webpack_public_path__ + "img/portfolio--agency-03.a449788a.jpg";